import React from 'react';
import { chipState } from './permissionMeta';

/**
 * A single OS-permission grant rendered as a ✓ / ✕ / – chip.
 * Meaning is carried by an aria-label (text), never colour alone.
 *
 * value: 1 / true / '1' / 'true' → granted (✓), 0 / false / '0' / 'false' → denied (✕),
 * null / undefined / anything unrecognised → not applicable (–). See chipState.
 */
const GLYPH = { granted: '✓', denied: '✕', na: '–' };
const LABEL = { granted: 'Granted', denied: 'Denied', na: 'Not applicable' };

const PermissionGrantChip = ({ value }) => {
  const state = chipState(value);
  return (
    <span className={`up-chip up-chip--${state}`} role="img" aria-label={LABEL[state]} title={LABEL[state]}>
      <span aria-hidden="true">{GLYPH[state]}</span>
    </span>
  );
};

export default PermissionGrantChip;
